import Fibra_1 from '../../images/FIBRA_1.jpg'
import Fibra_1_low from '../../images/FIBRA_1_low.jpg'
import Fibra_2 from '../../images/FIBRA_2.jpg'
import Fibra_2_low from '../../images/FIBRA_2_low.jpg'
import Fibra_5 from '../../images/FIBRA_5.jpg'
import { useIsMobile } from '../context/MobileContext'
import ProgressiveBackground from '../utils/ProgressiveBackground'

const FibraFotos:React.FC<{id?:number,width:number}>=({id, width})=>{

    const isMobile = useIsMobile()
    

    function getTransform(maxWidth:number){
        if(width<maxWidth){
            return(0)
        } else {
            return((width/2)-(maxWidth/2))
        }
    }

    const styleFotoMobile:React.CSSProperties = {
        float:'left', height:'250px', width:'100%', backgroundPositionX:'center'
        // float:'left', height:'250px', width:'100%', backgroundImage:'url("'+Fibra_1+'")', backgroundSize:'cover', backgroundPositionX:'center'
    }
    
    if(isMobile){
        return(
            <div style={{width:'100%',marginTop:'20px', height:'250px', position:'absolute', left:'0', maxWidth:'1600px', transform:'translate('+getTransform(1600)+'px, 0)'}}>
            {id==1&&(
                <ProgressiveBackground
                lowRes={Fibra_1_low}
                highRes={Fibra_1}
                style={styleFotoMobile}
                />
            // <div style={{float:'left', height:'250px', width:'100%', backgroundImage:'url("'+Fibra_1+'")', backgroundSize:'cover', backgroundPositionX:'center'}}></div>
            )}
            {id==2&&(
                <ProgressiveBackground
                lowRes={Fibra_2_low}
                highRes={Fibra_2}
                style={styleFotoMobile}
                />
            )}
            {id==3&&(
            <div style={{float:'left', height:'250px', width:'100%', backgroundImage:'url("'+Fibra_5+'")', backgroundSize:'cover', backgroundPositionX:'center'}}></div>
            )}
            <div style={{clear:'both'}}/>
        </div>
        )
    } else {
        return(
        <div style={{width:'100%',marginTop:'20px', height:'400px', position:'absolute', left:'0', maxWidth:'1600px', transform:'translate('+getTransform(1600)+'px, 0)'}}>
            <div style={{float:'left', height:'400px', width:'33.333%', backgroundImage:'url("'+Fibra_1+'")', backgroundSize:'cover', backgroundPositionX:'right'}}></div>
            <div style={{float:'left', height:'400px', width:'33.333%', backgroundImage:'url("'+Fibra_5+'")', backgroundSize:'cover', backgroundPositionX:'center'}}></div>
            <div style={{float:'left', height:'400px', width:'33.334%', backgroundImage:'url("'+Fibra_2+'")', backgroundSize:'cover', backgroundPositionX:'left'}}></div>
            <div style={{clear:'both'}}/>
        </div>
        )
    }
}

export default FibraFotos